import { render, staticRenderFns } from "./ParallaxStyle1.vue?vue&type=template&id=6aafb5d4"
import script from "./ParallaxStyle1.vue?vue&type=script&lang=js"
export * from "./ParallaxStyle1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports